import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'brand_leads-brands_page_intro_section-view';

/**
 * Record view event for intro section on brands page. Pass the name of the introduction section when track
 */
export function trackBrandLeadsBrandsPageIntroSectionView(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken },
  });
}
